module.exports = __webpack_public_path__ + "img/20190722164659354.94b552ab.png";